/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { pdfGeneratorGenerate } from '../fn/pdf-generator/pdf-generator-generate';
import { PdfGeneratorGenerate$Params } from '../fn/pdf-generator/pdf-generator-generate';
import { ReportResponse } from '../models/report-response';

@Injectable({ providedIn: 'root' })
export class PdfGeneratorService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `pdfGeneratorGenerate()` */
  static readonly PdfGeneratorGeneratePath = '/pdf-generator/generate';

  /**
   * API to generate report.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pdfGeneratorGenerate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pdfGeneratorGenerate$Response(params: PdfGeneratorGenerate$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportResponse>> {
    return pdfGeneratorGenerate(this.http, this.rootUrl, params, context);
  }

  /**
   * API to generate report.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pdfGeneratorGenerate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pdfGeneratorGenerate(params: PdfGeneratorGenerate$Params, context?: HttpContext): Observable<ReportResponse> {
    return this.pdfGeneratorGenerate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReportResponse>): ReportResponse => r.body)
    );
  }

}
